<template>
  <div id="htmlBoxQRCode" >
    <templatePrintSerialNumber :title="title" :note="note" :hotline="hotline" :key="componentPrint" :listData="lstProducts"/>
  </div>
  <!-- <div class="btn-box-print">
    <button class="print-selected" @click="popup"><i class="pi pi-print"></i><span>In QR Code</span></button>
  </div> -->
 
</template>

<script>
import DataServices from '@/core/DataServices'
import templatePrintSerialNumber from '../common/templatePrintSerialNumber'

export default {
  components: {
    templatePrintSerialNumber
  },
  data() {
    return {
      componentPrint:  Math.random() * 1201,
      title: '',
      note: '',
      hotline: '',
      lstProducts: [],
      enabled: false,
      maxLength: 3
    }
  },
  watch: {
    '$route': 'initParams'
  },
  created() {
    window.addEventListener('keydown', this.handler);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handler);
  },
  async mounted () {
    window.addEventListener("contextmenu", e => e.preventDefault());
    await this.initParams();
  },
  methods: {
    handler(e) {
      if (e.ctrlKey && this.enabled && (e.key === 'p' || e.key === 'P')) {
        this.popup();
      }
    },
    async getSettings() {
      var variables = {
        where_key: {
          key: {'_in': ['QR_SERIAL_NUMBER_TITLE', 'QR_SERIAL_NUMBER_NOTE', 'QR_SERIAL_NUMBER_HOTLINE']}
        },
        orderBy: {
          key: 'desc'
        }
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), 'fields' : 'key value'});
      if (data != undefined && data != null && data[Object.keys(data)].length) {
        var lists = data[Object.keys(data)];
        var objTitle = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_TITLE');
        if (objTitle && Object.keys(objTitle).length) {
          this.title = objTitle[0].value.trim();
        }
        var objNote = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_NOTE');
        if (objNote && Object.keys(objNote).length) {
          this.note = objNote[0].value.trim();
        }
        var objHotline = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_HOTLINE');
        if (objHotline && Object.keys(objHotline).length) {
          this.hotline = objHotline[0].value.trim();
        }
      }
    },
    
    async initParams() {
      var vm = this;
      if (vm.$route.query && Object.keys(vm.$route.query).length) {
        vm.maxLength = Number(vm.$route.query.num);
      }
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      await this.getSettings();
      var products = localStorage.getItem('products');
      if (products && products != null && vm.maxLength > 0) {
        var dataJson = JSON.parse(products);
        for (let index = 0; index < dataJson.length; index++) {
          var item = dataJson[index];
          for (let index = 0; index < vm.maxLength; index++) {
            this.lstProducts.push(item);
          }
        }
      }
      var callData  =  window.setInterval(async () => {
        var htmlBoxQRCode = document.getElementById('htmlBoxQRCode');
        if (typeof htmlBoxQRCode != 'undefined' && htmlBoxQRCode != null) {
          vm.$store.commit('setLoading', false);
          clearInterval(callData);
          vm.enabled = true;
        }
      }, 1000);
    },
    popup()  {
      var htmlBoxQRCode = document.getElementById('htmlBoxQRCode');
      var myWindow = window.open('', 'QR code', 'width=163');
      myWindow.document.write('<html><head><title>QR code</title>');
      // myWindow.document.write('<link rel="stylesheet" href="' +  window.origin + '/assets/css/print-qrcode.css" type="text/css" />');
      myWindow.document.write('<style type="text/css"> *, html, body {margin:0;padding:0;} ' + 
      '@font-face {' +
        'font-family: "Roboto-Regular";' +
        'src: url("' +  window.origin + '/assets/font/Roboto/Roboto-Regular.eot");' +
        'src: local("☺"), url("' +  window.origin + '/assets/font/Roboto/Roboto-Regular.woff") format("woff"), ' +
        'url("' +  window.origin + '/assets/font/font/Roboto/Roboto-Regular.ttf") format("truetype"), ' +
        'url("' +  window.origin + '/assets/font/Roboto/Roboto-Regular.svg") format("svg");' +
        'font-weight: normal;' +
        'font-style: normal;' +
      '}' +

      '@font-face {' +
        'font-family: "Roboto-Bold";' +
        'src: url("' +  window.origin + '/assets/font/Roboto/Roboto-Bold.eot");' +
        'src: local("☺"), url("' +  window.origin + '/assets/font/Roboto/Roboto-Bold.woff") format("woff"), ' +
        'url("' +  window.origin + '/assets/font/Roboto/Roboto-Bold.ttf") format("truetype"), ' +
        'url("' +  window.origin + '/assets/font/Roboto/Roboto-Bold.svg") format("svg");' +
        'font-weight: normal;' +
        'font-style: normal;' +
      '}' +

      '@font-face {' +
        'font-family: "UTM Avo";' +
        'src: url("' +  window.origin + '/assets/font/UTM/UTM Avo.eot");' +
        'src: local("☺"), ' +
        'url("' +  window.origin + '/assets/font/UTM/UTM Avo.woff") format("woff"), ' +
        'url("' +  window.origin + '/assets/font/UTM/UTM Avo.ttf") format("truetype"), ' +
        'url("' +  window.origin + '/assets/font/UTM/UTM Avo.svg") format("svg");' +
        'font-weight: normal;' +
        'font-style: normal;' +
      '}' +

      '@font-face {' +
        'font-family: "UTM AvoBold";' +
        'src: url("' +  window.origin + '/assets/font/UTM/UTM AvoBold.eot");' +
        'src: local("☺"), url("' +  window.origin + '/assets/font/UTM/UTM AvoBold.woff") format("woff"), ' +
        'url("' +  window.origin + '/assets/font/UTM/UTM AvoBold.ttf") format("truetype"), ' +
        'url("' +  window.origin + '/assets/font/UTM/UTM AvoBold.svg") format("svg");' +
        'font-weight: normal;' +
        'font-style: normal;' +
      '}' +
      '* { box-sizing: border-box; }' +

      'html {' +
        'box-sizing: border-box;' +
        'margin: 0mm;' +
      '}' +
      '*, *:before, *:after {' +
        'box-sizing: inherit;' +
      '}' +
      // '@page { margin: 10cm; }' +
      'body{margin: 0; padding: 0;} ' +
      '.txt-right{text-align: right;}' +
      '.board-item{position: relative; background: #fff; width: 5cm; padding: 0.1959cm 0.15cm 0.2331cm 0.15cm; margin: 0; margin-left: 0.3cm; page-break-after: always;}' +
      // '.board-item{background: #fff; width: 5cm; padding: 0; margin: 0; padding: 5pt 2pt 0 2pt; margin-left: 10pt; page-break-after: always; mso-header-margin: 2in;  mso-footer-margin: 0in;  mso-paper-source: 0}' +
      '.board-item table{border-collapse: collapse; width: 100%;}' +
      '.header-serial-number{ border-bottom: 1pt solid #000; display: table-row; } ' +
      '.header-serial-number .left-title { font-size: 6pt;/*font-size: 7.7pt;*/font-family: "Roboto-Bold"; line-height: 9pt; padding: 0; padding-bottom: 0.0139cm;} ' +
      '.header-serial-number .right-title { font-size: 7pt;font-family: "Roboto-Bold"; padding: 0;padding-bottom: 0.0139cm; position: absolute; top: 4.4pt; right: 0.15cm;} ' +
      '.body-serial-number{display: table-row; }' +
      '.body-serial-number .body-info {width: 2.6cm; padding: 0;}' +
      '.body-serial-number .note-info {font-size: 6.8pt; font-family: "UTM AvoBold"; line-height: 8.729pt; margin-bottom: 0.08cm; margin-top: 0.125cm;  position: relative; top: -0.0265cm;}' +
      '.body-serial-number .border-custom {padding-top: 0.03cm; font-size: 8.1pt; font-family: "UTM AvoBold"; border-top: 0.9232pt solid #000; border-bottom: 0.9232pt solid #000;  display: flex; width: 2.53cm; overflow: hidden;}' +
      '.body-info .border-custom img{margin-top: 0.075cm; width: 0.1726cm; top: -0.07cm; left: 0.03cm; position: relative; margin-right: 0.177cm;}' +
      '.body-serial-number .border-custom span{position: relative; margin-top: 0.0066cm; margin-bottom: 0.14cm; line-height: 9pt;}' +
      '.body-serial-number .serial {font-family: "UTM AvoBold"; text-align: left;}' +
      '.body-serial-number .serial span{font-size: 6.6pt; position: relative; top: 0.0158cm;}' +
      '.body-info .item-info abbr{display: block;font-size: 7.2pt; position: relative; top: 0.001cm;}' +
      '.body-qr .qr-custom{ width: 2cm; height: 2cm; margin: 0 auto; float: right; position: relative; margin-top:0.2cm;}' +
      '.qr-custom img{max-width: 100%; height: auto;}' +
      '</style>');
      myWindow.document.write('</head><body contextmenu="false">');
      myWindow.document.write(htmlBoxQRCode.innerHTML);
      myWindow.document.write('</body></html>');
      myWindow.document.close(); // necessary for IE >= 10

      myWindow.onload=function(){ // necessary if the div contain images
        myWindow.focus(); // necessary for IE >= 10
        myWindow.print();
        // myWindow.close();
      };
    }
  }
}
</script>

<style lang="scss">
.btn-box-print{position: absolute; top: 10px; left: 300px; cursor: pointer; border: 0 none; margin: 0; padding: 0;
  .print-selected{ align-items: center;  font-size: 14px; color: #fff;  border-width: 0px;  background: #009900; border: none; border-radius: 5px; padding: 5px 15px;
    i{padding-right: 10px;}
  }
}
.layout-wrapper{padding: 0; min-height: inherit;}
.layout-serial-number {border: 0 none;}
.board-item {page-break-after: always;}
</style>
